import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import { useCallback, useEffect, useState } from "react";
import styled from "styled-components"
import decodePolyline from "../../../helper/nakliyeHesaplama/decodePolyline";
import { useDispatch } from "react-redux";
import { setRouteDistance as setAddLoadRouteDistance } from "../../../features/addLoad/addLoadSlice";
import { setRouteDistance as setUpdateLoadRouteDistance } from "../../../features/updateLoad/updateLoadSlice";


const Container = styled.div`
  width: 100%;
`;

const mapOptions={
    streetViewControl: false, // Sokak görünümü kontrolünü kapatır
    mapTypeControl: false, // Harita tipi kontrolünü kapatır
    zoomControl: false, // Zoom kontrolünü kapatır
    gestureHandling: "greedy" // ctrl olayını kapatır
};

const alphabetList = ["A", "B", "C", "D", "E", "F", "G","H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]

const hasValidCoordinates = (item) =>
    item?.lat !== "" &&
    item?.lat != null &&
    item?.lng !== "" &&
    item?.lng != null &&
    Number.isFinite(Number(item.lat)) &&
    Number.isFinite(Number(item.lng))


const RoutesMapSection = ({route,  defaultLocation, zoom, from}) => {

    const [settedRoute, setSettedRoute] = useState([])

    const dispatch = useDispatch()

    const getRoutes = useCallback(async({origin, intermediates, destination}) => {
        const url = "https://routes.googleapis.com/directions/v2:computeRoutes";
        const headers = {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": process.env.REACT_APP_GOOGLE_API_KEY,
          "X-Goog-FieldMask": "*",
        };

        const body = {
          origin,
          destination,
          intermediates,
          travelMode: "DRIVE",
          polylineQuality: "HIGH_QUALITY",
          routingPreference: "TRAFFIC_AWARE_OPTIMAL",
          units: "METRIC",
        };

        try {
          const response = await fetch(url, {
            method: "POST",
            headers,
            body: JSON.stringify(body),
          });

          const data = await response.json();

          if (data.routes && data.routes.length > 0) {
            const decodedRoute = decodePolyline(data.routes[0].polyline.encodedPolyline)

            setSettedRoute(decodedRoute)

            const distanceInKilometers = Number(data.routes[0].distanceMeters) / 1000
            if (!Number.isFinite(distanceInKilometers)) return

            if(from === "add"){
                dispatch(setAddLoadRouteDistance(Math.trunc(distanceInKilometers)))
            }

            else if(from === "update"){
                dispatch(setUpdateLoadRouteDistance(Math.trunc(distanceInKilometers)))
            }
          }
        } catch (error) {
          console.error("Routes API çağrısı başarısız:", error);
        }
      }, [dispatch, from]);

    useEffect(() => {

        const validRoute = route.filter(item => {
            return hasValidCoordinates(item)
        })

        if(validRoute.length >= 2){
            const origin = {
                location: {
                latLng: {
                    latitude: parseFloat(validRoute[0].lat),
                    longitude: parseFloat(validRoute[0].lng)
                }
                }
            }
        
            //! burada yapılan en son eleman boş olabileceğinden değerleri dolu olan son elemanı buluyoruz
            const lastValidPoint = validRoute.findLast(item => {
                return item.lat && item.lng
            }) 
        
            const destination = {
                location: {
                latLng: {
                    latitude:  parseFloat(lastValidPoint?.lat),
                    longitude: parseFloat(lastValidPoint?.lng)
                }
                }
            }
        
            //! burada ara duraklar için ilk item olmamasına seçilen son item olmamasına ve lat ve lng lerinin boş olmamasına bakıyoruz
            const intermediates = validRoute.filter((item, i) => {
            return i !== 0 && item.lat !== lastValidPoint.lat && item.lng !== lastValidPoint.lng
            }).map((item) => {
            return{
                via: true,
                location: {
                latLng: {
                    latitude: parseFloat(item.lat),
                    longitude: parseFloat(item.lng)
                }
                }
            }
            })

            getRoutes({origin, intermediates, destination})
        }
          
    },[getRoutes, route])

  return (
    <Container>
        <GoogleMap mapContainerClassName="map-container" center={defaultLocation} zoom={zoom} options={mapOptions}>

            <Polyline
                path={settedRoute}
                options={{
                    strokeColor: "#E85446",
                    strokeWeight: 4,
                    zIndex: 5,
                }}
            />

            {
                route.filter(hasValidCoordinates).map((item, i) => (
                <Marker
                    key={i}
                    position={{
                    lat: parseFloat(item.lat),
                    lng: parseFloat(item.lng)
                    }}
                    label={{
                    text: alphabetList[i],
                    color: "#FFFFFF",
                    fontSize: "14px",
                    }}
                    options={{
                    color: "#fff"
                    }}
                />
                ))
            }
        </GoogleMap>
    </Container>
  )
}

export default RoutesMapSection
